export default __webpack_public_path__ + "18a82f891209397f73700d83c01473b5.png";